import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/system";
import { format } from "date-fns";
import styles from "../table.module.css";
import downarrow from "../../../../assets/images/arrowDrown.svg";
import uparrow from "../../../../assets/images/arrow_up.svg";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "#2036C7",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 400,
        border: "1px solid #EAECF0",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: 12,
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
    },
}));

const StyledTableRow = styled(TableRow)({});

const demandParameters = [
    "Agile plan",
    "Production actuals (tonnes)",
    "OR loss (tonnes)",
    "OEE (%)",
    "Projected production",
    "WTD (%)",
];

const AgileOrTable = ({ data }) => {

    const [expandedParameter, setExpandedParameter] = useState(null);
    const parameters = demandParameters;

    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split("-");
        return new Date(`${year}-${month}-${day}`);
    };

    const getAdditionalDataKeys = (param) => {
        const additionalData = data[0][param];
        return additionalData && typeof additionalData === "object"
            ? Object.keys(additionalData).filter((key) => key !== "value")
            : [];
    };

    const renderCellValue = (param, value) => {
        if (value == null) return "";

        if (typeof value === "object") {
            return value.hasOwnProperty("value") ? value.value.toFixed(1) : 0;
        }
        return typeof value === 'number' ? value.toFixed(1) : value;
    }

    const renderRowCells = (param, entry) => {
        let shouldHighlight;
        if(param === ("OR loss (tonnes)")){
            const parsedEntryDate = parseDate(entry.Date); 
            const today = new Date();
            const todayMidnight = new Date(today.setHours(0, 0, 0, 0));
        
            const isPastOrToday = parsedEntryDate <= todayMidnight;
        
            const value = entry[param];
            shouldHighlight = isPastOrToday && Math.sign(value?.value || value) === 1;
        }

        return (
            <StyledTableCell
                key={entry.Date}
                className={typeof entry[param] === "object" ? `${styles.fontRow}` : ''}
                sx={{ textAlign: "center" }}
            >
                {param === ("OR loss (tonnes)") ?
                    <span style={{
                        padding: '1px 10px',
                        borderRadius: '6px',
                        backgroundColor: shouldHighlight ? "#FF9998" : '#FFFFFF' // only highlight for today and past dates
                    }}>
                        {renderCellValue(param, entry[param])}
                    </span>
                   : renderCellValue(param, entry[param])
                }
            </StyledTableCell>
        );
    };

    const handleParameterClick = (param) => {
        setExpandedParameter((prev) => (prev === param ? null : param));
    };

    return (
        <TableContainer 
            className={styles.demandTable}
            sx={{
                '&::-webkit-scrollbar': {
                    width: '7px',
                    height: '7px',
                },
                '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '7px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '7px',
                }
            }}
        >
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Parameters</StyledTableCell>
                        {data?.map((entry, index) => (
                            <StyledTableCell key={index}>
                                {format(parseDate(entry.Date), "d MMM")}
                            </StyledTableCell>
                        ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {parameters.map((param) => (
                        <React.Fragment key={param}>
                            <StyledTableRow
                                className={data[0][param] && typeof data[0][param] === "object" ? styles.expandRow : ""}>
                                <StyledTableCell
                                    onClick={() => handleParameterClick(param)}
                                    className={data[0][param] && typeof data[0][param] === "object" ? `${styles.paramterRow} ${styles.fontRow}` : styles.paramterRow}>
                                    {typeof data[0][param] === "object" && (
                                        <img
                                            src={expandedParameter === param ? downarrow : uparrow}
                                            className={styles.plusIcon}
                                            alt="toggle"
                                        />
                                    )}
                                    {param}
                                </StyledTableCell>
                                {data.map((entry) => renderRowCells(param, entry))}
                            </StyledTableRow>
                            {expandedParameter === param &&
                                getAdditionalDataKeys(param).map((key) => (
                                    <StyledTableRow key={key}>
                                        <StyledTableCell><span style={{ marginLeft: "30px" }}>{key}</span></StyledTableCell>
                                        {data.map((entry) => (
                                            <StyledTableCell key={entry.Date} sx={{ textAlign: "center" }}>
                                                {entry[param]?.[key]?.toFixed(1)}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};


export default AgileOrTable;